import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=4c630c98&scoped=true"
import script from "./CardVideo.vue?vue&type=script&lang=js"
export * from "./CardVideo.vue?vue&type=script&lang=js"
import style0 from "./CardVideo.vue?vue&type=style&index=0&id=4c630c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c630c98",
  null
  
)

export default component.exports